import { Link, useLocation } from "react-router-dom";
import React from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import { navItems } from "./menu";
import logo from "./../../../components/asset/img/Excite WLL.png";

export default function SideBar() {
  const location = useLocation();

  // Collects leaf urls from a (possibly nested) children array
  const leafUrls = (children) =>
    children.flatMap((c) => (c.children ? leafUrls(c.children) : [c.url]));

  // A group is "open" if the current path matches any of its (possibly nested) children
  const groupIsActive = (children) =>
    leafUrls(children).some((url) => location.pathname === url || location.pathname.startsWith(url + "/"));

  // Renders one level of a nav item — recurses into a nested SubMenu when the
  // item itself has children (e.g. Finance > SeerBit), otherwise a leaf MenuItem.
  const renderItem = (item, key) => {
    if (item.children) {
      return (
        <SubMenu
          key={key}
          title={item.group}
          icon={<i className={item.iClass} />}
          defaultOpen={groupIsActive(item.children)}
        >
          {item.children.map((child, ci) => renderItem(child, ci))}
        </SubMenu>
      );
    }
    return (
      <MenuItem
        key={key}
        icon={<i className={item.iClass} />}
        active={location.pathname === item.url}
      >
        <Link to={item.url}>{item.category}</Link>
      </MenuItem>
    );
  };

  return (
    <ProSidebar collapsed={false}>
      <SidebarHeader>
        <img src={logo} style={{ width: "150px" }} alt="brand" />
      </SidebarHeader>

      <SidebarContent>
        <Menu iconShape="circle">
          <MenuItem>SALES AGENTS</MenuItem>
        </Menu>

        <Menu iconShape="circle">
          {navItems.map((item, index) => renderItem(item, index))}
        </Menu>
      </SidebarContent>

      <SidebarFooter style={{ padding: "10px" }}>
        &copy; {new Date().getFullYear()}
      </SidebarFooter>
    </ProSidebar>
  );
}
